import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/index-hotel')
  },
  {
    path: '*',
    component: () => import('../views/page-error')
  },
  {
    path: '/booking',
    name: 'Booking',
    component: () => import('../views/booking')
  },
  {
    path: '/hotels',
    name: 'Hotels',
    component: () => import('../views/hotels')
  },
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
